import { SilosStatIcon } from "./SummaryStatIcons";
import { SummaryStatVariant } from "../SummaryStatCard";

export const unpricedTons: SummaryStatVariant = {
  icon: <SilosStatIcon />,
  label: "Unpriced Tons",
};
